<template>
  <v-row>
    <v-col cols="12" class="pa-0">
      <time-card
        v-bind:inOutInfo="GET_IN_OUT_INFO"
        v-on:saveTimecard="saveTimecard()"
      />
    </v-col>
    <v-col cols="12" class="main-contents">
      <!-- [출퇴근] -->

      <div v-show="!GET_COMMON_LOADING_STATUS">
        <!-- [결제함] -->
        <btn-widget
          v-if="GET_WIDGET_USE_OBJ.apprDoc"
          v-bind:gubun="'applDoc'"
        />
        <!-- [내문서함] -->
        <btn-widget v-if="GET_WIDGET_USE_OBJ.myBox" v-bind:gubun="'mybox'" />

        <!-- [부서원 근태현황]-->
        <btn-widget
          v-if="GET_WIDGET_USE_OBJ.orgGntWork"
          v-bind:gubun="'org'"
        />
        <!-- [나의 근태/휴가 관리] -->
        <btn-widget
          v-if="GET_WIDGET_USE_OBJ.annualHoliday"
          v-bind:gubun="'vacationMyWorkHolidayMain'"
        />
        <!-- [급여명세서] -->
        <btn-widget v-if="GET_WIDGET_USE_OBJ.pay" v-bind:gubun="'pay'" />

        <!--사용안함-->
        <!-- [결재할문서] v-if="apprDocWidget" >
        <appr-doc-widget
          v-if="GET_WIDGET_USE_OBJ.apprDoc"
          v-bind:apprDocCnt="GET_APPR_DOC_CNT"
        /-->

        <!-- [부서원근태현황(목록)] >
        <org-gnt-work-widget
          v-if="GET_WIDGET_USE_OBJ.orgGntWorkL"
          v-bind:searchList="GET_EMP_LIST_BY_ORG"
        /-->

        <!-- [부서원근태현황(버튼)] >
        <btn-widget
          v-if="GET_WIDGET_USE_OBJ.orgGntWorkB"
          v-bind:gubun="'org'"
        /-->

        <!-- [근무현황] >
        <work-time-widget
          v-if="GET_WIDGET_USE_OBJ.workTime"
          v-bind:psnlWorkInfo="GET_PSNL_WORK_INFO"
        /-->
        <!-- [근무현황] >
        <btn-widget v-if="GET_WIDGET_USE_OBJ.workTime" v-bind:gubun="'workstatus'" /-->
        <!-- [연장근무신청]>
        <btn-widget
          v-if="GET_WIDGET_USE_OBJ.overtimeApp"
          v-bind:gubun="'overtimeApp'"
        / -->
        <!-- [연차현황] >
        <btn-widget
            v-if="GET_WIDGET_USE_OBJ.annualHoliday"
            v-bind:gubun="'holidaystatus'"
        /-->

        <!-- [연차현황]
        <annual-holiday-widget
          v-if="GET_WIDGET_USE_OBJ.annualHoliday"
          v-bind:restCnt="GET_PSNL_WORK_INFO.restCnt"
          v-bind:applBtnFlag="GET_APPL_MENU_USE_YN"
        /-->

        <!-- [배우자출산휴가] 
        <btn-widget
          v-if="GET_WIDGET_USE_OBJ.maternity"
          v-bind:gubun="'maternity'"
        /-->

        <!-- [연차휴가계획]
        <annual-plan
          v-if="GET_WIDGET_USE_OBJ.annualPlan && GET_MAIN_SHOW_FLAG"
        /-->

        <!-- [연장근무보상시간]
        <work-over-time-widget
          v-if="GET_WIDGET_USE_OBJ.workOverTime"
          v-bind:restTime="GET_WORK_OVER_REST_TIME"
          v-bind:applBtnFlag="GET_APPL_MENU_USE_YN"
        /-->

        <!-- [휴일근무현황] >
        <holiday-work-widget
          v-if="GET_WIDGET_USE_OBJ.holidayWork"
          v-bind:holWorkList="GET_HOL_WORK_LIST"
        /-->

        <!-- [연차 사용계획] -->
        <!-- <annual-use-plan-widget /> -->
      </div>

      <!-- main widget 스켈레톤 로더 -->
      <master-main-skeleton-loader v-show="GET_COMMON_LOADING_STATUS" />
    </v-col>
  </v-row>
</template>

<script>
/* 메인 위젯목록 컴포넌트 - 임원,조직장(팀장)용  */
import TimeCard from '@/components/main/TimeCard.vue';
import BtnWidget from '@/components/main/BtnWidget.vue';
//import WorkTimeWidget from '@/components/main/WorkTimeWidget.vue';
//import AnnualHolidayWidget from '@/components/main/AnnualHolidayWidget.vue';
//import ApprDocWidget from '@/components/main/ApprDocWidget.vue';
import WorkOverTimeWidget from '@/components/main/WorkOverTimeWidget.vue';
import AnnualPlan from '@/components/main/AnnualPlan.vue';
//import HolidayWorkWidget from '@/components/main/HolidayWorkWidget.vue';
//import OrgGntWorkWidget from '@/components/main/OrgGntWorkWidget.vue';
//import AnnualUsePlanWidget from '@/components/main/AnnualUsePlanWidget.vue';
import MasterMainSkeletonLoader from '@/components/main/mainWidgetList/MasterMainSkeletonLoader.vue';

import MainMixin from '@/mixins/mainMixin'; // ** main Mixin **

export default {
  mixins: [MainMixin],

  components: {
    TimeCard,
    BtnWidget,
    //WorkTimeWidget,
    //AnnualHolidayWidget,
    //ApprDocWidget,
    WorkOverTimeWidget,
    AnnualPlan,
    //HolidayWorkWidget,
    //OrgGntWorkWidget,
    MasterMainSkeletonLoader,
    // AnnualUsePlanWidget,
  },
};
</script>
